<template>
    <div class="tree__body">
        <a
            :href="this.prefix + '/familytree'"
            class="tree__body--btn link span"
        >
            <span>{{ $lang('welcome.ft.page')}}</span>
        </a>
        <div class="container romanov-section__welcome-container">
            <div class="romanov-section__romanov">
                <img class="romanov-section__romanov-image" src="/assets/front/img/family-tree/romanov-photo.png" alt="">
            </div>
            <div class="romanov-section__laptop">
                <img class="romanov-section__laptop-image" src="/assets/front/img/family-tree/laptop.png" alt="">
            </div>
            <div class="romanov-section__arrow">
                <img src="/assets/front/img/family-tree/arrow.png" alt="">
            </div>
        </div>
        <div class="romanov-section__info romanov-section__welcome-info">
            <h2 class="romanov-section__title">
                {{ $lang('romanov.title') }}
            </h2>
            <p class="romanov-section__text">
                {{ $lang('romanov.text') }}
            </p>
            <div class="romanov-section__btn-wrapper">
                <a
                    target="_blank"
                    href="https://familytree.memorycode.ru/share/22089346"
                    class="btn btn--big btn--main-bg romanov-section__link">
                    {{ $lang('welcome.ft.romanov') }}
                </a>
                <router-link
                    v-if="!isAuth"
                    :to="{ name: 'registration', query: {'redirect': '/cabinet/tree'} }"
                    class="link span"
                >
                    <span>{{ $lang('welcome.ft.tree')}}</span>
                </router-link>
                <a
                    v-if="isAuth"
                    :href="this.prefix +'/cabinet/tree'"
                    class="link span"
                >
                    <span>{{ $lang('MobileMenu.mine.ft') }}</span>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'WelcomeFamilyTree',
    data() {
        return {
            prefix: window.laravel.prefix,
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            isMaster: window.laravel.isMaster
        }
    },
    computed: {
        ...mapGetters('auth', [
            'isAuth',
        ]),
        isNotUser() {
            return this.isAdmin || this.isPartner || this.isMaster
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";


</style>
